import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { LulaLogo } from '@app/icons';
import history from '@app/services/history';
import { MouseEventHandler } from 'react';
import { pagesMeta } from '@app/services/pages-meta';
import clsx from 'clsx';

const useStyles = makeStyles<any>()({
  menu: {
    width: '124px',
  },
  menuItem: {
    cursor: 'pointer',
    transition: '1 all',
    '& .icon': {
      color: '#838383',
    },
    '& .title': {
      fontSize: 10,
      lineHeight: '14px',
      color: '#ccc',
    },
    '&:not(.active):hover': {
      '& .icon': {
        color: '#ddd',
      },
      '& .title': {
        fontSize: 10,
        lineHeight: '14px',
        color: '#ddd',
      },
    },
    '&.active': {
      '& .icon': {
        color: '#fff',
      },
      '& .title': {
        color: '#fff',
      },
    },
  },
});

export function SidebarMenu({ pageMeta }: any) {
  const { classes } = useStyles(null);

  const onNavigate =
    (uri: string): MouseEventHandler<any> =>
    () => {
      history.push(uri);
    };

  return (
    <>
      <Box
        alignItems="center"
        className={classes.menu}
        display="flex"
        flexDirection="column"
        flexGrow={1}
      >
        <Box display="flex" mt={5}>
          <LulaLogo title="Lula logo" width="30" />
        </Box>

        <Box
          alignItems="center"
          display="flex"
          flexDirection="column"
          mb={12}
          mt={8}
        >
          {pagesMeta
            .filter((pMeta) => pMeta.visible)
            .map((pMeta) => (
              <Box key={`menu-item-${pMeta.id}`} display="flex">
                <Box
                  className={clsx(
                    classes.menuItem,
                    pMeta.id === pageMeta?.id && 'active'
                  )}
                  display="flex"
                  flexDirection="column"
                  mt={3}
                  onClick={onNavigate(pMeta?.uri)}
                >
                  <Box className="icon" display="flex" justifyContent="center">
                    {pMeta.menuIcon}
                  </Box>
                  <Box
                    className="title"
                    display="flex"
                    justifyContent="center"
                    mt={1}
                  >
                    {pMeta?.menuTitle}
                  </Box>
                </Box>
              </Box>
            ))}
        </Box>
      </Box>
    </>
  );
}
